export default __webpack_public_path__ + "static/media/appstoreQr.c574fdfc.png";